export default {
  form: {
    bank_account_number: {
      label: 'Numero di conto',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Numero di routing',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Paese',
      placeholder: 'Germania',
    },
    bank_statement_descriptor: {
      label: 'Descrittore estratto conto',
      placeholder: 'Nome ristorante',
      tooltip: 'Questo nome verrà mostrato sugli estratti conto dei clienti',
    },
  },
  buttons: {
    next: 'Avanti',
    back: 'Indietro',
    use_test_data: 'Usa dati di test',
  },
  test_data_hint: 'Conto bancario di test accettato da {{gateways}}',
  read_only_warning:
    'Le informazioni bancarie possono essere modificate solo dal nostro team. Per aggiornarle, contatta il supporto.',
};
